import $ from "jquery";
import "@fancyapps/fancybox";
import "slick-slider";

$(document).ready(function () {
    $(".slider").slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        speed: 1000,
        draggable: false,
        centerMode: true,
        centerPadding: "60px",
        slidesToShow: 3,
    });
});

$(".responsive-slider").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    speed: 1000,
    draggable: false,
    centerMode: true,
    centerPadding: "60px",
    slidesToShow: 3,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                centerMode: false,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
            },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ],
});

$('[data-fancybox="gallery"]').fancybox({
    loop: true,
    wheel: false,
});
